import { CultureInfo } from '../culture-info.model';
import { CultureInfoPa } from './pa';

/**
 * @ignore
 */
export const CultureInfoPaGuru: CultureInfo = {
  name: 'pa-Guru',
  displayName: 'ਪੰਜਾਬੀ',
  iso3LanguageCode: 'pan',
  iso2LanguageCode: 'pa',
  ietfLanguageTag: 'pa-Guru',
  parent: CultureInfoPa
};
